import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { initSource } from "../../lib/source";
import AnnouncementBar from "./AnnouncementBar";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

export default function StoreLayout() {
  useEffect(() => { initSource(); }, []);
  return (
    <div className="flex min-h-screen flex-col bg-[#FBF1EE]">
      <AnnouncementBar />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
